var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[_c('v-pagination',{attrs:{"value":_vm.pagination.currentPage,"length":_vm.pagination.totalPages,"total-visible":10,"circle":""},on:{"input":_vm.handlePagination}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }